import React, {memo} from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { styles } from "./CustomerStrategy";

export default function ProductRecommendationStrategy({ productRecommendationStrategySuggestions, loading, showNoSuggestionsIndicator, error }) {

    return (
        <Box mt={{ xs: "14px", sm: "20px" }}>
            <Box component="h1" sx={styles.headingLarge}>
                Product Recommendation Strategy
            </Box>

            <Box component={Paper} sx={styles.paper}>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={[styles.tableCell, styles.summaryCol]}>
                                    Summary
                                </TableCell>
                                <TableCell sx={[styles.tableCell, styles.descriptionCol]}>
                                    Description
                                </TableCell>
                                <TableCell
                                    sx={[styles.tableCell, styles.countCol]}
                                    align="right"
                                >
                                    Count
                                </TableCell>
                                <TableCell sx={[styles.tableCell, styles.expandCol]} />
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loading && (
                                <TableRow>
                                    <TableCell sx={styles.tableCell}>
                                        <CircularProgress sx={{color: "#003300"}}  size={24}/>
                                    </TableCell>
                                </TableRow>
                            )}

                            {!loading && showNoSuggestionsIndicator && (
                                <TableRow>
                                    <TableCell sx={styles.tableCell} colSpan={6}>
                                        Product recommendation strategy not available
                                    </TableCell>
                                </TableRow>
                            )}

                            {!loading && !showNoSuggestionsIndicator && error && (
                                <TableRow>
                                    <TableCell sx={styles.tableCell} colSpan={6}>
                                        Failed to load product recommendation strategy
                                    </TableCell>
                                </TableRow>
                            )}

                            {!loading  && !showNoSuggestionsIndicator && !error && productRecommendationStrategySuggestions?.map((row, idx) => {
                                const key = `${row?.name ?? "row"}-${idx}`;

                                return (
                                    <TableRow key={key}>
                                        <TableCell
                                            sx={[styles.tableCell, styles.summaryCol]}
                                        >
                                            <Box sx={styles.noEllipsis}>{row?.name ?? "-"}</Box>
                                        </TableCell>

                                        <TableCell sx={[styles.tableCell, styles.descriptionCol]}>
                                            <Box sx={styles.noEllipsis}>{row?.description ?? "-"}</Box>
                                        </TableCell>

                                        <TableCell
                                            sx={[styles.tableCell, styles.countCol]}
                                            align="right"
                                        >
                                            <Box sx={styles.noEllipsis}>{row?.count ?? "-"}</Box>
                                        </TableCell>
                                        <TableCell sx={[styles.tableCell, styles.expandCol]} />
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}